'use client'
import { type FC, useEffect, useState } from 'react'
import styled from 'styled-components'
import { motion, AnimatePresence, type Variants } from 'motion/react'
import { useEntryAnimation } from '@/hooks'
import { Figure } from '@/components'

const mediaLogo = {
  type: 'svg' as const,
  src: '/images/svg/logo--portella.svg',
  alt: 'Portella logotype',
  size: { width: 623, height: 89 }
}


export const EntryAnimation:FC = () => {
  const { shouldFadeIn } = useEntryAnimation()
  const [pointerEvents, setPointerEvents] = useState<'auto' | 'none'>('auto')

  useEffect(()=> {
    queueMicrotask(() => setPointerEvents(shouldFadeIn ? 'none' : 'auto'))
  }, [shouldFadeIn])


  return (
    <AnimatePresence>
      {shouldFadeIn && (
        <Background variants={variants} initial='initial' animate='animate' exit='exit' $pointerEvents={pointerEvents}>
          <Figure media={mediaLogo}/>
        </Background>
      )}
    </AnimatePresence>
  )
}

export default EntryAnimation

// STYLES AND VARIANTS
const Background = styled(motion.div) <{ $pointerEvents: 'auto' | 'none' }>`
  align-items: center;
  background-color: var(--color-background);
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  left: 0;
  justify-content: center;
  opacity: 1;
  pointer-events: ${({ $pointerEvents }) => $pointerEvents};
  position: fixed;
  top: 0;
  user-select: none;
  width: 100%;
  z-index: 9999;

  figure {
    height: 28px;
    width: 196px;
  }
`


const variants: Variants = {
  initial: {
    opacity: 1,
    pointerEvents: 'none',
    transition: {
      duration: 2,
    }
  },
  animate: {
    opacity: 1,
    pointerEvents: 'auto',
    transition: {
      delay: 1,
      duration: 1,
      ease: 'easeOut'
    }
  },
  exit: {
    opacity: 0,
    pointerEvents: 'none',
    transition: {
      duration: 1,
      ease: 'easeOut'
    }
  }
}
